module.exports = __webpack_public_path__ + "img/51626514_L.af2f6106.png";